export default __webpack_public_path__ + "static/media/img-0027.4557fd6f.png";